import React from 'react';
import enhance from './InfluencerProposalItem.enhancer';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import LinkText from '../shared/components/LinkText';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import { dealStatuses } from '../../constants';
import MessageDrawer from '../shared/components/MessageDrawer';

class InfluencerProposalItem extends React.Component {
  constructor() {
    super();

    this.initialState = {
      isMessageDrawerOpen: false
    };

    this.state = {
      ...this.initialState
    };
  }

  navigateToProfile(userId) {
    this.props.history.push(`/user/${userId}/profile`);
  }

  shortlistDeal(deal) {
    if (!deal.isShortlisted) {
      this.props.shortlistDealHandler(deal);
    }
  }

  openMessageDrawer() {
    this.setState({
      isMessageDrawerOpen: true
    });
  }

  unmatchDealHandler(dealId, companyId) {
    this.props.unmatchDealClick(dealId, companyId);
  }

  sentFromInfluencer(deal) {
    if (!deal.currentProposal) {
      return true;
    }
    return deal.currentProposal.sender === deal.influencerId;
  }

  showEscrow = () => {
    return this.props.deal.status === dealStatuses.DEAL_ACCEPTED;
  };

  closeMessageDrawer() {
    this.setState({
      isMessageDrawerOpen: false
    });
  }

  render() {
    const { classes, deal, openViewProposal, auth } = this.props;
    const { isMessageDrawerOpen } = this.state;

    return (
      <React.Fragment>
        <div className={classes.dealContainer}>
          <Grid container spacing={2} direction="column">
            <Grid container item sm={12} direction="row">
              <Grid item sm={4} md={2}>
                <img
                  src={deal.user.profilePictureUrl}
                  className={classes.circleImage}
                />
              </Grid>
              <Grid item container direction="column" sm={8} md={3}>
                <LinkText
                  className={classes.displayName}
                  onClick={() => this.navigateToProfile(deal.user.uid)}
                >
                  {deal.user.displayName}
                </LinkText>
                <Typography>
                  Subscribers:{' '}
                  {deal.user.youtube ? deal.user.youtube.subscribers : 'N/A'}
                </Typography>
                <Typography>
                  Ave. Views:{' '}
                  {deal.user.youtube ? deal.user.youtube.averageViews : 'N/A'}
                </Typography>
              </Grid>
              <Grid item sm={12} md={7} align="right">
                <Tooltip title={'reject this proposal'} placement="left">
                  <Fab
                    className={classes.rejectFab}
                    size="small"
                    aria-label="reject"
                    onClick={() =>
                      this.unmatchDealHandler(deal.id, deal.companyId)
                    }
                  >
                    <ThumbDownIcon />
                  </Fab>
                </Tooltip>
                <Tooltip title={'shortlist this proposal'} placement="left">
                  <Fab
                    className={`${classes.shortlistFab} ${
                      deal.isShortlisted ? classes.shortlistedFab : ''
                    }`}
                    size="small"
                    aria-label="reject"
                    onClick={() => this.shortlistDeal(deal)}
                  >
                    <ThumbUpIcon />
                  </Fab>
                </Tooltip>
                <Button
                  variant="contained"
                  className={classes.messageButton}
                  onClick={() => this.openMessageDrawer()}
                >
                  Message
                </Button>

                {this.sentFromInfluencer(deal) && !this.showEscrow() && (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.viewProposalButton}
                    onClick={() => openViewProposal(deal)}
                  >
                    View Proposal
                  </Button>
                )}
                {!this.sentFromInfluencer(deal) && !this.showEscrow() && (
                  <div className={classes.proposalSentText}>
                    <Typography>Proposal Sent</Typography>
                  </div>
                )}
                {this.showEscrow() && (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.viewProposalButton}
                    onClick={() => this.props.viewEscrowFundsClick(deal)}
                  >
                    Escrow Funds
                  </Button>
                )}
              </Grid>
              {/* </div>
            </Grid> */}
            </Grid>
            <Grid
              item
              container
              direction="column"
              xs={12}
              spacing={2}
              className={classes.bottomRow}
            >
              <Typography className={classes.payoutText}>
                {deal.currentProposal ? `$${deal.currentProposal.payout}` : ''}
              </Typography>
              <div className={classes.proposedContentContainer}>
                <Typography
                  display="inline"
                  className={classes.contentTitleText}
                >
                  {deal.currentProposal ? 'Proposed Content - ' : ''}
                </Typography>
                <Typography display="inline">
                  {deal.currentProposal
                    ? ` ${deal.currentProposal.contentDetails}`
                    : ''}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <MessageDrawer
          isOpen={isMessageDrawerOpen}
          onClose={() => this.closeMessageDrawer()}
          auth={auth}
          sendTo={deal.user}
        />
      </React.Fragment>
    );
  }
}

export default enhance(InfluencerProposalItem);



// WEBPACK FOOTER //
// ./src/components/company/InfluencerProposalItem.js